import * as t from './types'

export default {
  [t.ADD_NEWSLETTER_PENDING]: (state) => {
    this.addNewsLetterStatus = ''
  },
  [t.ADD_NEWSLETTER_SUCCESS]: (state, { result }) => {
    console.log(result)
    state.addNewsLetterStatus = result.resultCd
  },
  [t.ADD_NEWSLETTER_FAIL]: (state) => {
  },
  [t.ADD_RECRUIT_PENDING]: (state) => {
    state.addRecruitStatus = ''
  },
  [t.ADD_RECRUIT_SUCCESS]: (state, { result }) => {
    console.log(result)
    state.addRecruitStatus = result.resultCd
  },
  [t.ADD_RECRUIT_FAIL]: (state) => {
  },
  [t.ADD_PROJECT_PENDING]: (state) => {
    state.addProjectStatus = ''
  },
  [t.ADD_PROJECT_SUCCESS]: (state, { result }) => {
    console.log(result)
    state.addProjectStatus = result.resultCd
  },
  [t.ADD_PROJECT_FAIL]: (state) => {
  },
  [t.ADD_PDS_PENDING]: (state) => {
    state.addPdsStatus = ''
  },
  [t.ADD_PDS_SUCCESS]: (state, { result }) => {
    console.log(result)
    state.addPdsStatus = result.resultCd
  },
  [t.ADD_PDS_FAIL]: (state) => {
  }
}
